import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { roleHome } from '../utils/roleHome';

const ProtectedRoute = ({ children, adminOnly = false, clientAllowed = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading">Laden...</div>;
  }

  if (!user) {
    // Ziel merken (z. B. /task/123 aus einer Benachrichtigungsmail), damit der
    // Login danach genau dorthin zurückführt.
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }

  // Admin-only routes: bounce non-admins to their role home
  if (adminOnly && user.role !== 'admin') {
    return <Navigate to={roleHome(user)} replace />;
  }

  // Internal-only routes (time tracking, billing, internal dashboard):
  // external clients are bounced to their PM home.
  if (!clientAllowed && user.role === 'client') {
    return <Navigate to={roleHome(user)} replace />;
  }

  return children;
};

export default ProtectedRoute;
